import React, { Component } from 'react';
import { connect } from 'react-redux';
import Entrance from 'components/entrance';
import { getExerciseList } from 'actions/record';

// 入口页 显示当前测评状态
class EntranceContainer extends Component {
  render() {
    return (
      <Entrance {...this.props} />
    );
  }
}


const mapStateToProps = state => ({
  logo: state.logo,
});

export default connect(mapStateToProps, {
  getExerciseList,
})(EntranceContainer);




// WEBPACK FOOTER //
// ./src/containers/entrance.js